<template>
  <label
    class="auth-register__policy"
    for="policy">
    <input
      id="policy"
      name="policy"
      type="checkbox"
      @change="$emit('change', $event.target.checked)">
    <span class="checkbox-mark"></span>
    <div class="checkbox-text">Я принимаю условия <a :href="url" target="_blank">политики конфиденциальности</a></div>
  </label>
</template>

<script>
  export default {
    name: 'Policy',
    model: {
      prop: 'checked',
      event: 'change'
    },
    props: {
      checked: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        url: 'http://aitech1.ru/help/payment/%D0%B4%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80_%D0%BE%D1%84%D0%B5%D1%80%D1%82%D0%B0.pdf'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Auth/Register/Policy.vue